import React from 'react';

import { DropdownContainer } from './styles';

const Dropdown = ({ children, className, open }) => {
  return (
    <DropdownContainer className={`${className} ${open ? 'open' : 'closed'}`}>
      <div className="header-menu-arrow" />
      {children}
    </DropdownContainer>
  );
};

export default Dropdown;
